import { makeAutoObservable } from 'mobx'
import { percentFormatter, scales } from 'widgets/PresentationMode/store/constants'

export class ImageControllerStore {
  scale = 1
  page = 1
  numPages = 0

  constructor() {
    makeAutoObservable(this)
  }

  get scalePercent() {
    return percentFormatter.format(this.scale)
  }

  get isFirstScale() {
    return this.scale <= scales[0]
  }

  get isLastScale() {
    return this.scale >= scales[scales.length - 1]
  }

  get isFirstPage() {
    return this.page <= 1
  }

  get isLastPage() {
    return this.page >= this.numPages
  }

  onScalePlus = () => {
    const currentIndex = scales.findIndex((scale) => scale === this.scale)
    if (currentIndex === -1) {
      const plusIndex = scales.findIndex((scale) => scale > this.scale)
      this.scale = scales[plusIndex]
      return
    }
    if (currentIndex === scales.length - 1) {
      return
    }
    this.scale = scales[currentIndex + 1]
  }

  onScaleMinus = () => {
    const currentIndex = scales.findIndex((scale) => scale === this.scale)
    if (currentIndex === 0) {
      return
    }
    if (currentIndex === -1) {
      const plusIndex = scales.findIndex((scale) => scale > this.scale)
      this.scale = scales[plusIndex - 1]
      return
    }
    this.scale = scales[currentIndex - 1]
  }

  setScale = (scale: number) => {
    this.scale = scale
  }

  setNumPages = (numPages: number) => {
    this.numPages = numPages

    if (this.page > numPages) this.page = numPages || 1
  }

  onNextPage = () => {
    if (!this.isLastPage) this.page += 1
  }

  onPrevPage = () => {
    if (!this.isFirstPage) this.page -= 1
  }
}
